import { CoreMenu } from '@core/types';
import { coreConfig } from 'app/app-config';
export const menu: CoreMenu[] = [
    //AHORROS
  // Apps & Pages
  {
    id: 'productos',
    type: 'section',
    title: 'Ahorros',
    modo: coreConfig.app.appSuscription,
    role: ['Socio'], // To set multiple role: ['Admin', 'Client', 'Socio']
    translate: 'MENU.AHORROS.SECTION',
    icon: 'home',
    children: [
      {
        id: 'productos',
        title: 'Mis ahorros',
        translate: 'MENU.APPS.EMAIL',
        type: 'item',
        icon: 'list',
        url: 'ahorros/productos'
      },
      {
        id: 'productos',
        title: 'Estados de cuenta',
        translate: 'MENU.APPS.EMAIL',
        type: 'item',
        icon: 'list',
        url: 'ahorros/estado-cuenta'
      },
      //Junta: Coment
      // {
      //   id: 'productos',
      //   title: 'Certificado cuentas',
      //   translate: 'MENU.APPS.EMAIL',
      //   type: 'item',
      //   icon: 'list',
      //   url: 'certificados'
      // }
    ]
  },
    //Creditos
  {
    id: 'apps',
    type: 'section',
    title: 'Créditos',
    modo: coreConfig.app.appSuscription,
    role: ['Socio'], // To set multiple role: ['Admin', 'Client', 'Socio']
    translate: 'MENU.APPS.SECTION',
    icon: 'credit-card',
    children: [
      {
        id: 'email',
        title: 'Consultar creditos',
        translate: 'MENU.APPS.EMAIL',
        type: 'item',
        icon: 'list',
        url: 'creditos/listado',
        data: { title: 'MyApplication' }
      },

      //Consultas web, comenta: Consulta soliciutd, solicitud credito
      //Edu Napo, comentar: Consulta soliciutd, solicitud credito y simulador
      // {
      //   id: 'email',
      //   title: 'Consultar solicitudes',
      //   translate: 'MENU.APPS.EMAIL',
      //   type: 'item',
      //   icon: 'list',
      //   url: 'creditos/solicitudes'
      // },
      // {
      //   id: 'email',
      //   title: 'Solicitar crédito',
      //   translate: 'MENU.APPS.EMAIL',
      //   type: 'item',
      //   icon: 'list',
      //   url: 'creditos/crear'
      // },
      {
        id: 'email',
        title: 'Simulador crédito',
        translate: 'MENU.APPS.EMAIL',
        type: 'item',
        icon: 'list',
        url: 'creditos/simulador'
      },
    ]
  },

  //Autorizaciones Ahorros y Retiros
  // {
  //   id: 'apps',
  //   type: 'section',
  //   title: 'Autorizaciones',
  //   modo: coreConfig.app.appSuscription,
  //   role: ['Socio'], // To set multiple role: ['Admin', 'Client', 'Socio']
  //   translate: 'MENU.APPS.SECTION',
  //   icon: 'credit-card',
  //   children: [
  //     {
  //       id: 'email',
  //       title: 'Ahorros',
  //       translate: 'MENU.APPS.EMAIL',
  //       type: 'item',
  //       icon: 'list',
  //       url: 'autorizaciones/ahorros',
  //       data: { title: 'Autorizaciones de ahorros' }
  //     },
  //   ]
  // },

  //Inversiones
  {
    id: 'apps',
    type: 'section',
    title: 'Inversiones',
    modo: coreConfig.app.appSuscription,
    role: ['Socio'], // To set multiple role: ['Admin', 'Client', 'Socio']
    translate: 'MENU.APPS.SECTION',
    icon: 'bar-chart',
    children: [
      {
        id: 'email',
        title: 'Consultar inversiones',
        translate: 'MENU.APPS.EMAIL',
        type: 'item',
        icon: 'list',
        url: 'inversiones/listado'
      },
      /*{
        id: 'email',
        title: 'Simulador Inversión',
        translate: 'MENU.APPS.EMAIL',
        type: 'item',
        icon: 'list',
        url: 'creditos/solicitud'
      }*/
    ]
  },

  //Descuentos
  {
    id: 'apps',
    type: 'section',
    title: 'Descuentos',
    modo: coreConfig.app.appSuscription,
    role: ['Socio'], // To set multiple role: ['Admin', 'Client', 'Socio']
    translate: 'MENU.APPS.SECTION',
    icon: 'package',
    children: [
      {
        id: 'email',
        title: 'Consultar descuentos',
        translate: 'MENU.APPS.EMAIL',
        type: 'item',
        icon: 'list',
        url: 'descuentos/listado'
      }
    ]
  },
    //Garantias
    {
      id: 'gara',
      type: 'section',
      title: 'Garantias',
      modo: coreConfig.app.appSuscription,
      role: ['Socio'], // To set multiple role: ['Admin', 'Client', 'Socio']
      translate: 'MENU.APPS.SECTION',
      icon: 'credit-card',
      children: [
        {
          id: 'gara',
          title: 'Consultar garantias',
          translate: 'MENU.APPS.EMAIL',
          type: 'item',
          icon: 'list',
          url: 'garantias/listado'
        }
      ]
    },
    
  //Transferencias
  //Junta: Comment y Consultas web
  // {
  //   id: 'transferencias',
  //   type: 'section',
  //   title: 'Transferencias',
  //   modo: 'full',
  //   role: ['Socio'], // To set multiple role: ['Admin', 'Client', 'Socio']
  //   translate: 'MENU.APPS.SECTION',
  //   icon: 'package',
  //   children: [
  //     {
  //       id: 'transferencias',
  //       title: 'Registrar cuentas',
  //       modo: 'full',
  //       translate: 'MENU.APPS.EMAIL',
  //       type: 'item',
  //       icon: 'list',
  //       url: 'transferencias/registrar-cuentas'
  //     },
  //     {
  //       id: 'transferencias',
  //       title: 'Listado cuentas',
  //       translate: 'MENU.APPS.EMAIL',
  //       type: 'item',
  //       icon: 'list',
  //       url: 'transferencias/listado-cuentas'
  //     },
  //     {
  //       id: 'transferencias',
  //       title: 'Transferencias Directas',
  //       translate: 'MENU.APPS.EMAIL',
  //       type: 'item',
  //       icon: 'list',
  //       url: 'transferencias/transferencias-internas'
  //     },
  //     {
  //       id: 'transferencias',
  //       title: 'Transferencias Interbancarias',
  //       translate: 'MENU.APPS.EMAIL',
  //       type: 'item',
  //       icon: 'list',
  //       url: 'transferencias/interbancarias'
  //     }
  //   ]
  // }
];
